import axios from 'axios';
import {useState, useEffect} from 'react';

import {URLS} from '../config';
import {ArticlesType} from '../types/ArticlesType';

export const useGetArticles = () => {
  const [articles, setArticles] = useState<ArticlesType[]>([]);
  const [articlesLoading, setArticlesLoading] = useState<boolean>(false);

  const getArticles = async () => {
    setArticlesLoading(true);

    try {
      const response = await axios.get(URLS.GET_ARTICLES_LOCAL);
      setArticles(response.data.articles);
    } catch (error) {
      console.error(error);
    } finally {
      setArticlesLoading(false);
    }
  };

  useEffect(() => {
    getArticles();
  }, []);

  return {articlesLoading, articles};
};
